"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPubkeyListMatchRuleV2 = exports.getPubkeyListMatchRuleV2Serializer = exports.pubkeyListMatchV2 = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const rule_1 = require("./rule");
const ruleHeader_1 = require("./ruleHeader");
const ruleType_1 = require("./ruleType");
const pubkeyListMatchV2 = (field, publicKeys) => ({
    type: 'PubkeyListMatch',
    field,
    publicKeys: publicKeys.map((program) => (0, umi_1.publicKey)(program)),
});
exports.pubkeyListMatchV2 = pubkeyListMatchV2;
const getPubkeyListMatchRuleV2Serializer = () => (0, ruleHeader_1.wrapSerializerInRuleHeaderV2)(ruleType_1.RuleTypeV2.PubkeyListMatch, (0, serializers_1.struct)([
    ['field', (0, serializers_1.string)({ size: 32 })],
    ['publicKeys', (0, serializers_1.array)((0, serializers_1.publicKey)(), { size: 'remainder' })],
]));
exports.getPubkeyListMatchRuleV2Serializer = getPubkeyListMatchRuleV2Serializer;
const isPubkeyListMatchRuleV2 = (rule) => (0, rule_1.isRuleV2)(rule) && rule.type === 'PubkeyListMatch';
exports.isPubkeyListMatchRuleV2 = isPubkeyListMatchRuleV2;
//# sourceMappingURL=pubkeyListMatch.js.map